// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\StripeConnectStatusResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type StripeConnectStatusApiResponse = {
	hasActionRequired: boolean;
	currentlyDue: Array<string>;
	disabledReason: string | null;
	currentDeadline: string | null;
};

export type StripeConnectStatus = {
	hasActionRequired: boolean;
	currentlyDue: Array<string>;
	disabledReason: string | null;
	currentDeadline: DateTime | null;
};

export function hydrateStripeConnectStatus(data: StripeConnectStatusApiResponse): StripeConnectStatus {
	return {
		...data,
		currentDeadline: DateTimefromISO(data.currentDeadline),
	};
}